export const allowedIconsIds = [
    'arrowRightIcon', 'cartIcon', 'arrowCornerIcon', 'searchIcon',
    'locationIcon', 'catalogOpenIcon', 'plusIcon', 'minusIcon',
    'marketIcon', 'checkIcon', 'layoutListIcon', 'layoutGridIcon',
    'telephoneIcon', 'restartIcon', 'playIcon', 'endPointIcon', 'menuIcon',
    'closeIcon', 'likeIcon',
]
export const defaultIcon = allowedIconsIds[0]

export const themes = ['default', 'dark', 'gray', 'light', 'transparent-border', 'transparent']
export const defaultTheme = themes[0]

export const types = ['default', 'text', 'icon']
export const defaultType = types[0]

export const sizes = ['default', 'medium', 'small', 'tiny']
export const defaultSize = sizes[0]